import {
    ExclamationCircleIcon,
    CheckCircleIcon
} from "@heroicons/react/24/solid";

const NotificationClaim = ({ legit, error }) => {
    return (
        <div className={`notification ${legit ? "legit" : "not-legit"}`}>
            {legit ? (
                <CheckCircleIcon className="w-6 h-6 mr-2 flex-shrink-0" />
            ) : (
                <div className="flex items-center">
                    <ExclamationCircleIcon className="w-6 h-6 mr-2 flex-shrink-0" />
                    {error && <span className="error">{error}</span>}
                </div>
            )}
            <span>
                {legit
                    ? "Questo prodotto è autentico!"
                    : "Questo prodotto potrebbe essere contraffatto"}
            </span>
        </div>
    );
};

export default NotificationClaim;
